// components/IdentityForm.js
import { TextField, Button } from "@mui/material";
import { CloudUpload, FileDownload } from "@mui/icons-material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Autocomplete from "@mui/material/Autocomplete";
import TypePiece from "../../shared/TypePiece";
import { apiUrl } from "../../config/config";

const IdentityForm = ({
  formData,
  errors,
  handleChange,
  handleFieldFocus,
  handleFileChange,
  setErrorDate,
  errorDate,
  newFile = {
    file: null,
    document_parcelle: null,
  },
  action = "ajout",
}) => (
  <div className="flex flex-col justify-center items-center space-y-5 mt-8 mb-8">
    <Autocomplete
      id="typepiece"
      options={TypePiece}
      size="small"
      fullWidth
      onChange={(event, value) => handleChange("piece", value?.name || "")}
      onFocus={() => handleFieldFocus("piece")}
      value={TypePiece.find((piece) => piece.name === formData.piece) || null}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Type de pièce"
          error={!!errors.piece}
          helperText={errors.piece}
        />
      )}
    />
    <TextField
      label="Numéro de la pièce"
      fullWidth
      size="small"
      value={formData.numero_piece}
      onChange={(e) => handleChange("numero_piece", e.target.value)}
      onFocus={() => handleFieldFocus("numero_piece")}
      error={!!errors.numero_piece}
      helperText={errors.numero_piece}
      required
    />

    <div className="w-full">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          sx={{ width: "100%" }}
          label="Date Etablissement"
          format="DD/MM/YYYY"
          defaultValue={dayjs(formData.date_piece)}
          onChange={(value) => {
            // Formater la date au format "yyyy/mm/dd" avec Dayjs
            const formattedDate = dayjs(value).format("YYYY/MM/DD");
            // Appeler la fonction handleChange avec la date formatée
            handleChange("date_etablissement", formattedDate);
            setErrorDate(false);
          }}
          slotProps={{
            textField: {
              error: errorDate,
              helperText: errors.date_piece,
            },
          }}
        />
      </LocalizationProvider>
    </div>
    <TextField
      label="Lieu d'établissement de la pièce"
      fullWidth
      size="small"
      value={formData.lieu_etablissement}
      onChange={(e) =>
        handleChange("lieu_etablissement", e.target.value.toUpperCase())
      }
      onFocus={() => handleFieldFocus("lieu_piece")}
      error={!!errors.lieu_piece}
      helperText={errors.lieu_piece}
      required
    />
    {action === "ajout" && (
      <>
        <p className="mt-2 mb-2 text-sm text-yellow-400 font-bold">
          Importer la Pièce d'identité en pdf (2Mo maximum)
        </p>
        <Button
          component="label"
          variant="contained"
          startIcon={<CloudUpload />}
          role={undefined}
        >
          Importer la pièce
          <input type="file" accept=".pdf" hidden onChange={handleFileChange} />
        </Button>
        {formData.file && (
          <p className="text-green-700">{formData.file.name}</p>
        )}
        {errors.file && <p className="text-red-600">{errors.file}</p>}{" "}
      </>
    )}
    {action === "modification" && (
      <>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudUpload />}
        >
          Modifier votre pièce
          <input
            type="file"
            accept=".pdf"
            hidden
            onChange={(event) => handleFileChange(event)}
          />
        </Button>
        <p className="mt-2 mb-2 text-sm text-yellow-400 font-bold">
          Le fichier doit etre en pdf (2Mo maximum)
        </p>
        {newFile.file && (
          <>
            <strong>Nouveau fichier:</strong>
            <div className={`text-blue-800`}>{newFile.file.name}</div>
          </>
        )}
        {formData.photo_piece && (
          <>
            <a
              href={apiUrl + `/storage/${formData.photo_piece}`}
              target="_blank"
              rel="noreferrer"
            >
              <FileDownload color={`primary`} sx={{ fontSize: 40 }} />
            </a>
            {formData.photo_piece}
          </>
        )}
        {errors.photo_piece && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-500">
            {errors.photo_piece}
          </p>
        )}
      </>
    )}
  </div>
);

export default IdentityForm;
